const distributorColorScheme = {
  default: {
    primary: "#008577",
    secondary: "#DCF2F1",
  },
};

export default distributorColorScheme;
